import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
const initialState = {
  loading: true,
  error: null,
  data: null,
  page: 1,
  count: 0,
};

export const getAdminAllClubsApi = createAsyncThunk(
  "adminClubs/getAllClubs",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/clubs/getAllClubs?page=${data.page}&search=${data.search}&sortBy=${data.sortColumn}&sortOrder=${data.sortOrder}`,
        {
          headers: {
            Authorization: `Bearer ${data.token}`,
          },
        },
      );

      if (res.data?.success) {
        return {
          data: res.data?.data?.rows || [],
          page: res.data?.metaData?.page || 1,
          count: res.data?.data?.count || 0,
        };
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data.message);
      }
    } catch (error) {
      if (error?.response) {
        toast.error(error.response.data.message);
        return rejectWithValue(error.response.data.message);
      } else {
        toast.error(error.message);
        return rejectWithValue(error.message);
      }
    }
  },
);

const userSlice = createSlice({
  name: "allClubsAdmin",
  initialState,
  reducers: {
    deleteClubFromState: (state, action) => {
      state.data = state.data.filter((data) => data.id !== action.payload.id);
    },
    deleteClubVideoFromState: (state, action) => {
      const { clubId, videoId } = action.payload;
      state.data = state.data.map((club) => {
        if (club.id === clubId) {
          return {
            ...club,
            ClubGoals: club.ClubGoals.filter((video) => video.id !== videoId),
          };
        } else {
          return club;
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdminAllClubsApi.pending, (state, action) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getAdminAllClubsApi.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.data = action.payload.data;
        state.page = action.payload.page;
        state.count = action.payload.count;
      })
      .addCase(getAdminAllClubsApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload;
      });
  },
});

const { actions, reducer } = userSlice;

export const { deleteClubFromState, deleteClubVideoFromState } = actions;
export default reducer;
